import { render, staticRenderFns } from "./interpretationNotice.vue?vue&type=template&id=b53459d4&scoped=true"
import script from "./interpretationNotice.vue?vue&type=script&lang=js"
export * from "./interpretationNotice.vue?vue&type=script&lang=js"
import style0 from "./interpretationNotice.vue?vue&type=style&index=0&id=b53459d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53459d4",
  null
  
)

export default component.exports